import React from 'react';
import '../css/genstyle.css';

export const FormErrors = ({formErrors}) =>
    <div className='w100p alignLeft'>
        { formErrors !== ''? <div className="errText">{formErrors}</div> : '' }
    </div>